<script setup lang="ts">
/** Tiny inline SVG line chart; null points (missing data) are skipped. */
import { computed } from 'vue'

const props = withDefaults(defineProps<{ values: (number | null)[]; label: string; width?: number; height?: number }>(), { width: 120, height: 28 })

const points = computed(() => {
  const vs = props.values.filter((v): v is number => v != null)
  if (vs.length < 2) return ''
  const min = Math.min(...vs)
  const span = Math.max(...vs) - min || 1
  const step = props.width / Math.max(1, props.values.length - 1)
  return props.values
    .map((v, i) => (v == null ? null : `${(i * step).toFixed(1)},${(props.height - 2 - ((v - min) / span) * (props.height - 4)).toFixed(1)}`))
    .filter(Boolean)
    .join(' ')
})
</script>

<template>
  <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" role="img" :aria-label="label">
    <polyline v-if="points" :points="points" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
  </svg>
</template>

<style scoped>
svg {
  color: var(--accent);
  vertical-align: middle;
}
</style>
